export const constant = {
	selector: {
		target: '.js-input-change-handler',
	},
	attribute: {
		url: 'data-js-input-change-url',
	},
	parameters: {
		valuePlaceholder: '%23input-value',
	},
}
